//'use strict'

import axios from 'axios'
import store from '@/store'
import auth from '@/api/auth'

const _axios = axios.create()

_axios.defaults.baseURL = process.env.VUE_APP_API_URL
_axios.defaults.withCredentials = false
_axios.defaults.timeout = 25000
_axios.defaults.headers = {}

// Add a request interceptor
_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers.Authorization = localStorage.getItem('accessToken') || null
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  response => {
    return response
  },
  async error => {
    // console.log(error); // Error: timeout of 20000ms exceeded
    const { config, response: { status, data } } = error
    const originalRequest = config
    
    // jwt expired
    if (status === 401 && data === 'Unauthorized1') {
      return new Promise((resolve) => {
        auth.refreshToken((flag, accessToken) => {
          if (flag) {
            originalRequest.headers.Authorization = accessToken
            resolve(axios(originalRequest))
          } else {
            store.dispatch('logout')
            window.location.href = '/'
            return Promise.reject(new Error('로그인이 만료 되었습니다.'))
          }
        })
      })
    } else {
      await store.dispatch('logout')
      window.location.href = '/'
      return Promise.reject(new Error('로그인이 만료 되었습니다.'))
    }
  }
)

export default _axios
